import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    filmilox: {
        white: '#fff',
    },
});

export default theme;
